__turbopack_context__.v({
  "formColumns": "accountRegistration-module-scss-module__TXD3kq__formColumns",
  "inlineValidationError": "accountRegistration-module-scss-module__TXD3kq__inlineValidationError",
  "passwordWrapper": "accountRegistration-module-scss-module__TXD3kq__passwordWrapper",
  "privacyPolicy": "accountRegistration-module-scss-module__TXD3kq__privacyPolicy",
  "registerButton": "accountRegistration-module-scss-module__TXD3kq__registerButton",
  "submitStatus": "accountRegistration-module-scss-module__TXD3kq__submitStatus",
  "termsContainer": "accountRegistration-module-scss-module__TXD3kq__termsContainer",
  "toggleVisibility": "accountRegistration-module-scss-module__TXD3kq__toggleVisibility",
  "usernameDisclaimer": "accountRegistration-module-scss-module__TXD3kq__usernameDisclaimer",
  "wrapper": "accountRegistration-module-scss-module__TXD3kq__wrapper",
});
